'use client';
import styled, { css } from 'styled-components';

import { Theme } from '@utils/types';

import { IContainer } from '.';

const variantStyles = (theme: Theme, maxWidth = 'xl') =>
  ({
    lg: css`
      padding-left: 12px;
      padding-right: 12px;

      ${theme.mediaQueries.LARGE_1X_UP} {
        max-width: 1200px;
        padding: 0px;
      }
    `,
    xl: css`
      padding-left: 12px;
      padding-right: 12px;

      ${theme.mediaQueries.LARGE_1X_UP} {
        max-width: 1536px;
        padding-left: 24px;
        padding-right: 24px;
      }
    `,
  }[maxWidth]);

export const Wrapper = styled.div<IContainer>`
  box-sizing: border-box;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  display: block;

  ${({ theme, maxWidth }) => variantStyles(theme, maxWidth)}
  ${({ noPadding }) => noPadding && `padding: 0`};
`;
